// import { Routes, Route } from "react-router-dom"

import Toolbar from '../components/toolbar/toolbar';
import AboutMe from "../components/pages/AboutMe/about_me";

import './App.css'

function App() {

  return (
    <div className="App">
        <Toolbar />
        <AboutMe />
        {/* <Routes>
            <Route path="/" element={<AboutMe />} />
        </Routes> */}
    </div>
  );
}

export default App;
